import { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
} from 'recharts'
import { useZsInstanceUsages } from '../../../../zustand-store'

interface Props {}

const LiveInstanceUsage: React.FC<Props> = (props) => {
    const ref = useRef<any>()
    const { t } = useTranslation()
    const containerOWRef = useRef<number>(1088)
    const [containerWidth, setContainerWidth] = useState(1088)

    const { instances } = useZsInstanceUsages()

    useEffect(() => {
        function handleResize() {
            if (
                ref.current &&
                ref.current.offsetWidth !== containerOWRef.current
            ) {
                containerOWRef.current = ref.current.offsetWidth
                setContainerWidth(ref.current.offsetWidth)
            }
        }
        window.addEventListener('resize', handleResize)
        handleResize()
        return () => {
            window.removeEventListener('resize', handleResize)
        }
    }, [])

    return (
        <div
            className="min-w-full overflow-hidden overflow-x-auto align-middle shadow sm:rounded-lg  "
            ref={ref}
        >
            <BarChart
                width={containerWidth}
                height={300}
                data={instances}
                margin={{
                    top: 5,
                    right: 0,
                    left: 0,
                    bottom: 5,
                }}
            >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="instance" />
                <YAxis />
                <Tooltip />
                <Legend verticalAlign="top" height={36} />
                <Bar
                    dataKey="activeUsers"
                    name={t('Live users / Instance')}
                    maxBarSize={15}
                    fill="#8884d8"
                />
            </BarChart>
        </div>
    )
}

export default LiveInstanceUsage
